import { render, staticRenderFns } from "./select-ds.vue?vue&type=template&id=52c777ae&scoped=true&"
import script from "./select-ds.vue?vue&type=script&lang=ts&"
export * from "./select-ds.vue?vue&type=script&lang=ts&"
import style0 from "./select-ds.vue?vue&type=style&index=0&id=52c777ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c777ae",
  null
  
)

export default component.exports